export const RESOURCE_TYPES = {
    ROOT: 'ROOT_CATEGORY',
    MAIN: 'MAIN_CATEGORY',
    SUB: 'SUB_CATEGORY',
    ENTRY: 'ENTRY',
};

/**
 * Fetch a list of main category slugs from the categories list
 * @return {string[]} The main category slugs
 */
export function getMainCategorySlugs() {
    return globals.config.project.resources
        .filter(({ type }) => type === RESOURCE_TYPES.MAIN)
        .map(({ slug }) => slug);
};
